<!-- @format -->

<info-bank-account-tag>

    <div class="container_contents">

        <div class="container_breadcrumb">
            <ul class="breadcrumb">
                <li class="breadcrumb-item"><a href="/info" class="information">会員情報</a></li>
                <li class="breadcrumb-item"><h1>銀行口座の登録・変更</h1></li>
            </ul>

        </div><!--/.container_breadcrumb-->

        <div class="contents">
            <section class="contents_area">
                <div class="contents_block">

                    <h2 style="font-size: 2.5rem;text-align: center;margin-bottom:1rem">
                        銀行口座の登録・変更
                    </h2>

                    <div>
                        <p if={(state.exists_basic_information || state.exists_basic_information_application) && bankAccount.bank_account_status===1}
                           style="font-size:1.4rem;font-weight:bold;text-align:center">
                            現在以下の内容を運営事務局で確認中です。しばらくお待ちください。
                        </p>
                        <p if={(state.exists_basic_information || state.exists_basic_information_application) && bankAccount.bank_account_status===2}
                           style="font-size:1.4rem;font-weight:bold;text-align:center"
                           class="note">
                            銀行口座情報に確認が必要な状態です。<a href="/info/bank-account">こちらのページ</a>から内容のご確認と修正を行ってください。
                        </p>
                    </div>

                    <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">
                        銀行口座情報
                    </h2>

                    <div is="bank-confirm"></div>

                </div>
            </section>
        </div>
    </div>


    <script>
        import bankConfirm from "@tags/parts/info/bank-account/confirm.riot";
        import bankAccount from "@model/bankAccount/api";
        import di from "dependeny-injection";

        export default {
            components: {
                'bank-confirm': bankConfirm
            },
            bankAccount: bankAccount,
            state: {
                exists_basic_information: false,
                exists_basic_information_application: false,
            },
            listenerUpdate() {
                this.update()
            },
            onMounted(props, state) {
                console.log("22222222");
                this.bankAccount.on('update', this.listenerUpdate)

                this.api = di.createApi('info');
                const my = this;
                this.api.request('index', 'fetch')
                    .then(data => {
                        my.state.exists_basic_information = (Object.keys(data.basic_information).length >= 2);
                        my.state.exists_basic_information_application = data.basic_information.application;
                        my.update();
                    })
            },
            onUnmounted(props, state) {
                this.bankAccount.off('update', this.listenerUpdate)
            }
        }
    </script>
</info-bank-account-tag>
